<app-nav titulo="Nueva cotización" descripcion="Cotice una garantía en función del alquiler y las expensas de la propiedad.">
    <div class="new-quote">
        <mat-horizontal-stepper linear class="form-stepper" #stepper>

            <!-- ───────────────── STEP 1: COTIZAR ───────────────── -->
            <mat-step [completed]="quoteResult">
                <ng-template matStepLabel>Cotizar</ng-template>

                <!-- Contenido del cotizador -->
                <div class="form-step quotation-step">
                    <form class="quote-form-wrapper" [formGroup]="quoteFG" (ngSubmit)="formIsReady && getQuoteResult()">

                    <!-- COLUMNA IZQUIERDA: Propiedad + Cobertura -->
                    <div class="left-column">
                    <div class="property-selector">
                        <h3 class="form-step-title">Datos de la Propiedad</h3>

                        <!-- Tipo de propiedad -->
                        <mat-radio-group class="form-radio-line" formControlName="tipo" color="primary">
                            <span class="radio-line-label">Tipo de propiedad</span>
                            <div class="radios">
                                <mat-radio-button *ngFor="let type of quoteTypes" [value]="type.codigo"
                                    [disabled]="quoteFG.value.propiedad && quoteFG.value.propiedad.tipo !== type.codigo && quoteFG.value.propiedad.tipo !== 'AMBOS'">
                                    {{ type.descripcion }}
                                </mat-radio-button>
                            </div>
                        </mat-radio-group>

                        <span class="form-step-description">Opcionalmente puede seleccionar una propiedad ya creada en el sistema.</span>
                        <div class="property-selection-box not-selected" *ngIf="!quoteFG.controls.propiedad.value">
                            <span class="not-selected-message">No se ha seleccionado una propiedad</span>
                            <button mat-raised-button color="primary" type="button"
                                class="garantor-button mini select-property-button"
                                (click)="openSelectPropertyModal()">
                                Seleccionar propiedad
                            </button>
                        </div>
                        <div class="property-selection-box selected" *ngIf="quoteFG.controls.propiedad.value">
                            <button mat-icon-button type="button" class="delete-property-button" color="accent"
                                (click)="quoteFG.controls.propiedad.setValue(undefined)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <span class="address">
                                {{ quoteFG.value.propiedad.direccion.calle }} {{ quoteFG.value.propiedad.direccion.numero }}
                            </span>
                            <span class="floor-department">
                                <span class="floor" *ngIf="quoteFG.value.propiedad.direccion.piso">
                                    <b>Piso: </b>{{ quoteFG.value.propiedad.direccion.piso }}
                                </span>
                                <span class="department" *ngIf="quoteFG.value.propiedad.direccion.departamento">
                                    <b>Dpto: </b>{{ quoteFG.value.propiedad.direccion.departamento }}
                                </span>
                            </span>
                            <span class="locality">
                                {{ quoteFG.value.propiedad.direccion.localidad.descripcion }},
                                {{ quoteFG.value.propiedad.direccion.localidad.municipio.descripcion }},
                                {{ quoteFG.value.propiedad.direccion.localidad.provincia.descripcion }}
                            </span>
                        </div>
                    </div>

                    <!-- Cobertura incluida -->
                    <div class="bond-type-selector">
                        <h3 class="form-step-title">Cobertura incluida</h3>

                        <div class="fianza-placeholder" *ngIf="!selectedTipoFianza">
                            <span class="form-step-description">Seleccione un producto para ver los servicios incluidos.</span>
                        </div>

                        <div class="fianza-detail" *ngIf="selectedTipoFianza">
                            <span class="form-step-description">{{ selectedTipoFianza.nombre }}</span>
                            <div class="bond-services">
                                <span class="service-chip" *ngFor="let svc of selectedFianzaServicios">
                                    {{ svc }}
                                </span>
                            </div>
                            <div class="fianza-meta">
                                <span class="meta-item">
                                    <b>Plazo:</b> {{ selectedTipoFianza.plazoMinMeses }} – {{ selectedTipoFianza.plazoMaxMeses }} meses
                                </span>
                                <span class="meta-item">
                                    <b>Coeficiente mensual:</b> {{ selectedTipoFianza.coeficientePrimaMensual | number:'1.2-4' }}
                                </span>
                            </div>
                        </div>

                    </div>
                    </div><!-- /left-column -->

                    <!-- Formulario de cotización -->
                    <div class="quote-parameters">
                        <h3 class="form-step-title">Datos de cotización</h3>
                        <span class="form-step-description">Ingrese los datos de la propiedad a cotizar.</span>

                        <div class="quote-form">

                            <!-- Agente (solo CORPORATIVO / OFICINA) [full width] -->
                            <ng-container *ngIf="user.tipo === 'CORPORATIVO' || user.tipo === 'OFICINA'">
                                <div class="agent-selection-box not-selected" *ngIf="!broker">
                                    <span class="not-selected-message">
                                        No se ha seleccionado ningún agente
                                        <ng-container *ngIf="user.tipo === 'OFICINA'">(opcional: se puede asignar más adelante)</ng-container>
                                    </span>
                                    <button mat-raised-button color="primary" type="button"
                                            class="garantor-button mini select-broker-button"
                                            (click)="openSelectBrokerModal()">
                                        Seleccionar agente
                                    </button>
                                </div>
                                <div class="agent-selection-box selected" *ngIf="broker">
                                    <button mat-icon-button type="button" class="delete-broker-button" color="accent"
                                            (click)="broker = undefined; resetForm()">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                    <span class="broker-name">
                                        <b>Agente:</b> {{ broker.nombre }} {{ broker.apellido }}
                                    </span>
                                    <span class="office-name">
                                        <b>Oficina:</b> {{ broker.oficina.nombre }}
                                    </span>
                                </div>
                            </ng-container>

                            <!-- Zona + Producto/Fianza -->
                            <mat-form-field class="garantor-form-field" appearance="outline">
                                <mat-label>Zona / Agrupación</mat-label>
                                <mat-select formControlName="idZona"
                                    (selectionChange)="onZonaChange($event.value)">
                                    <mat-option [value]="null">Sin zona (Default)</mat-option>
                                    <mat-option *ngFor="let zona of zonas" [value]="zona.id">
                                        {{ zona.nombre }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="garantor-form-field" appearance="outline">
                                <mat-label>Producto / Fianza</mat-label>
                                <mat-select formControlName="idTipoFianza"
                                    (selectionChange)="onFianzaChange($event.value)">
                                    <mat-option *ngIf="tiposFianza.length === 0" disabled>
                                        No hay fianzas disponibles
                                    </mat-option>
                                    <mat-option *ngFor="let fianza of tiposFianza" [value]="fianza.id">
                                        {{ fianza.nombre }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="quoteFG.controls['idTipoFianza'].hasError('required')">
                                    Por favor seleccione un producto
                                </mat-error>
                            </mat-form-field>

                            <!-- Alquiler + Expensas -->
                            <div class="amount-row">
                                <mat-form-field class="currency-field garantor-form-field" appearance="outline">
                                    <mat-label>Moneda</mat-label>
                                    <mat-select formControlName="monedaAlquiler">
                                        <mat-option *ngFor="let m of monedas" [value]="m.codigo">{{ m.descripcion }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="amount-field garantor-form-field" appearance="outline">
                                    <mat-label>Alquiler</mat-label>
                                    <input matInput formControlName="alquiler" type="number">
                                    <span matPrefix>$ &nbsp;</span>
                                    <mat-error *ngIf="quoteFG.controls['alquiler'].hasError('required')">
                                        Por favor ingrese el alquiler
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="amount-row">
                                <mat-form-field class="currency-field garantor-form-field" appearance="outline">
                                    <mat-label>Moneda</mat-label>
                                    <mat-select formControlName="monedaExpensas">
                                        <mat-option *ngFor="let m of monedas" [value]="m.codigo">{{ m.descripcion }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="amount-field garantor-form-field" appearance="outline">
                                    <mat-label>Expensas</mat-label>
                                    <input matInput formControlName="expensas" type="number">
                                    <span matPrefix>$ &nbsp;</span>
                                    <mat-error *ngIf="quoteFG.controls['expensas'].hasError('required')">
                                        Por favor ingrese las expensas
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <!-- Tipo de cambio [full width, solo si moneda alquiler = USD] -->
                            <mat-form-field class="garantor-form-field full-width-field" appearance="outline" *ngIf="mostrarTipoCambio">
                                <mat-label>Tipo de cambio</mat-label>
                                <input matInput formControlName="tipoCambio" type="number">
                                <span matPrefix>$ &nbsp;</span>
                                <mat-hint>Valor de referencia ARS por USD</mat-hint>
                            </mat-form-field>

                            <!-- Plazo + Tipo de descuento -->
                            <mat-form-field class="garantor-form-field" appearance="outline">
                                <mat-label>Plazo en meses</mat-label>
                                <input matInput formControlName="duracion" type="number">
                                <mat-hint>{{ plazoHint }}</mat-hint>
                                <mat-error *ngIf="quoteFG.controls.duracion.hasError('required')">
                                    Por favor ingrese el plazo
                                </mat-error>
                                <mat-error *ngIf="quoteFG.controls.duracion.hasError('min')">
                                    El plazo mínimo para este producto es {{ selectedTipoFianza?.plazoMinMeses ?? 1 }} meses
                                </mat-error>
                                <mat-error *ngIf="quoteFG.controls.duracion.hasError('max')">
                                    El plazo máximo para este producto es {{ selectedTipoFianza?.plazoMaxMeses ?? 120 }} meses
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="garantor-form-field" appearance="outline">
                                <mat-label>Tipo de descuento</mat-label>
                                <mat-select formControlName="idTipoDescuento"
                                    (selectionChange)="onTipoDescuentoChange($event.value)">
                                    <mat-option *ngIf="tiposDescuentoFiltrados.length === 0" disabled>
                                        No hay tipos de descuento disponibles
                                    </mat-option>
                                    <mat-option *ngFor="let td of tiposDescuentoFiltrados" [value]="td.id">
                                        {{ td.nombre }}
                                        <span class="descuento-detail">&nbsp;(tope {{ td.tope }}%)</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- % Descuento comercial (solo si hay un tipo de descuento seleccionado) -->
                            <mat-form-field class="garantor-form-field" appearance="outline" *ngIf="mostrarPorcentajeRenovacion">
                                <mat-label>% Descuento</mat-label>
                                <input matInput formControlName="porcentajeRenovacion" type="number" style="text-align: right;">
                                <span matSuffix>&nbsp; %</span>
                                <mat-hint *ngIf="selectedTipoDescuento?.tope">
                                    Máximo {{ selectedTipoDescuento.tope }}%
                                </mat-hint>
                                <mat-error *ngIf="quoteFG.controls['porcentajeRenovacion'].hasError('required')">
                                    Por favor ingrese el porcentaje de descuento
                                </mat-error>
                                <mat-error *ngIf="quoteFG.controls['porcentajeRenovacion'].hasError('max')">
                                    El tope máximo es {{ selectedTipoDescuento?.tope }}%
                                </mat-error>
                            </mat-form-field>

                            <!-- Datos de actualización [full width] -->
                            <p class="form-section-label">Datos de actualización</p>

                            <!-- % Actualización + Período -->
                            <mat-form-field class="garantor-form-field" appearance="outline">
                                <mat-label>% Actualización</mat-label>
                                <input matInput formControlName="actualizacion" type="number" style="text-align: right;">
                                <span matSuffix>&nbsp; %</span>
                            </mat-form-field>

                            <mat-form-field class="garantor-form-field" appearance="outline">
                                <mat-label>Período</mat-label>
                                <mat-select formControlName="periodoActualizacion">
                                    <mat-option [value]="null">—</mat-option>
                                    <mat-option *ngFor="let period of updatePeriods" [value]="period.codigo">
                                        {{ period.descripcion }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Tipo de actualización + Comercial -->
                            <mat-form-field class="garantor-form-field" appearance="outline">
                                <mat-label>Tipo de actualización</mat-label>
                                <mat-select formControlName="tipoActualizacion">
                                    <mat-option *ngFor="let opt of tipoActualizacionOptions" [value]="opt.codigo">
                                        {{ opt.descripcion }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="garantor-form-field" appearance="outline" *ngIf="mostrarInputCustom">
                                <mat-label>Especificar actualización</mat-label>
                                <input matInput formControlName="tipoActualizacionCustom" placeholder="Ej: CVS, otro índice...">
                            </mat-form-field>

                            <mat-form-field class="garantor-form-field" appearance="outline" *ngIf="comerciales.length">
                                <mat-label>Comercial</mat-label>
                                <mat-select formControlName="idComercial">
                                    <mat-option [value]="null">Sin asignar</mat-option>
                                    <mat-option *ngFor="let c of comerciales" [value]="c.id">
                                        {{ c.nombre }} {{ c.apellido }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Datos del solicitante -->
                            <p class="form-section-label">Datos del solicitante (opcional)</p>

                            <div class="name-row">
                                <mat-form-field class="half-field garantor-form-field" appearance="outline">
                                    <mat-label>Nombre</mat-label>
                                    <input matInput formControlName="nombre" type="text">
                                </mat-form-field>
                                <mat-form-field class="half-field garantor-form-field" appearance="outline">
                                    <mat-label>Apellido</mat-label>
                                    <input matInput formControlName="apellido" type="text">
                                </mat-form-field>
                            </div>

                            <div class="dni-row">
                                <mat-form-field class="half-field garantor-form-field" appearance="outline">
                                    <mat-label>DNI / CUIT</mat-label>
                                    <input matInput formControlName="dniCuit" type="text">
                                </mat-form-field>
                                <mat-checkbox class="half-field garantor-checkbox" formControlName="perfilAprobado" color="primary">
                                    Perfil aprobado
                                </mat-checkbox>
                            </div>

                            <div class="dni-row">
                                <mat-checkbox class="half-field garantor-checkbox" formControlName="incluir12Cuotas" color="primary">
                                    Incluir 12 cuotas en el PDF
                                </mat-checkbox>
                            </div>

                            <button mat-raised-button color="accent" class="garantor-button quote-button"
                                [disabled]="!formIsReady">
                                Cotizar
                            </button>
                        </div>
                    </div>

                    </form>
                </div>
            </mat-step>

            <!-- ───────────────── STEP 2: RESULTADO ───────────────── -->
            <mat-step>
                <ng-template matStepLabel>Resultado de su cotización</ng-template>
                <div class="form-step details-form-step" *ngIf="quoteResult">
                    <h3 class="form-step-title">Resultado de su cotización</h3>
                    <span class="form-step-description">Estas son las opciones disponibles para su garantía.</span>

                    <app-quote-result [quote]="quoteResult"></app-quote-result>

                    <!-- Deshabilitado temporalmente: no se debe mostrar la comisión de Garantor por el momento
                    <span class="commission">
                        Comisión Remax: <b>$ {{ utilsService.beautifyNumber(commission ? commission.total : 0, 2) }}</b>
                    </span>
                    <span class="commission">
                        Comisión para pago financiado: <b>$ {{ utilsService.beautifyNumber(commission ? commission.totalFinanciado : 0, 2) }}</b>
                    </span>
                    -->

                    <div class="form-step-buttons">
                        <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>
                            Volver a cotizar
                        </button>
                        <button mat-raised-button color="accent" type="button" class="garantor-button start-warranty-button"
                            *ngIf="user.tipo === 'AGENTE' || user.tipo === 'CORPORATIVO'"
                            (click)="validadDisponibilidadPropiedad(quoteResult)">
                            Comenzar garantía
                        </button>
                    </div>
                </div>
            </mat-step>

        </mat-horizontal-stepper>
    </div>
</app-nav>
